
<template>
<div class="page">
    <div class="content">
      <div class="p1">
        <img src="../assets/img/s-back.png" alt="">
      </div>
      <!-- 实体商业 -->
      <div class="con c_con">
        <div class="con_a lbox1">
        </div>
        <div class="con_b lbox2">
          <p style="margin-bottom: 0.312rem;font-size: 1.456rem;">实体商业智慧运营</p>
          <p>服务平台</p>
        </div>
        <div class="con_c">
          <div style="font-size: 0.94rem;">企鹅智慧</div>
          <div style="font-size: 0.832rem;white-space: nowrap;line-height: 1.664rem;">
            <p>研发的智慧商业应用平台，是一个领先的实体商业智慧运营服务平台。</p>
            <p>服务包括互动营销、会员管理、会员服务、线上商城、大数据监控、消费者BI等功能。</p>
            <p>通过移动端会员应用+会员数据服务为商场/购物中心提供“商业地产新零售”整体解决方案。</p>
            <p>产品自上线以来，服务了包括五环体育、印象城，阳光天地，悦秀城、MOMOPARK等众多商业综合体，</p>
            <p>以模块+定制的服务模式为各大商业中心提供独一无二的个性化智慧零售平台应用。目前，企鹅智慧已成为腾讯智慧零售ISV产品。</p>
            <p>已实现包括科传、长益、富基、商通、ETCP、迅捷、立方、停车王等在内的多家商业管理服务软件集成。</p>
          </div>

        </div>
      </div>

      <!-- 互动营销 -->
      <div class="hd">
        <div class="hd_ct">
          <div>
            <div><img src="../assets/img/i-xdyx1.png" alt=""></div>
            <p class="text">互动营销</p>
          </div>
          <div>
            <div><img src="../assets/img/i-xcx2.png" alt=""></div>
            <p class="text">小程序直播</p>
          </div>
          <div>
            <div><img src="../assets/img/i-hy3.png" alt=""></div>
            <p class="text">会员服务</p>
          </div>
          <div>
            <div><img src="../assets/img/i-xs4.png" alt=""></div>
            <p class="text">线上商城</p>
          </div>
          <div>
            <div><img src="../assets/img/i-dsj5.png" alt=""></div>
            <p class="text">大数据监控</p>
          </div>
          <div>
            <div><img src="../assets/img/i-xfz6.png" alt=""></div>
            <p class="text">消费者BI</p>
          </div>
        </div>
      </div>
      <!-- 直击商业 -->
      <div class="c_con direct">
            <div class="con_a lbox1" style="margin-left: 48%;">
            </div>
            <div class="con_b" style="font-size: 1.456rem;">
                <p >直击商业经营痛点</p>
                <p>提供“商业新零售”解决方案</p>
            </div>
            <div class="separation">
              <router-link to="/page/page1">
                <div :class="flag4=='-1' ? 'pc_box':''" @click="change('-1')">慧客-会员管理产品</div>
              </router-link>
              <router-link to="/page/page2">
                <div :class="flag4=='2' ? 'pc_box':''" @click="change('2')">慧购-线上销售产品</div>
              </router-link>
              <router-link to="/page/page3">
                <div :class="flag4=='3' ? 'pc_box':''" @click="change('3')">慧投-媒介整合营销</div>
              </router-link>
              <router-link to="/page/page4">
                <div :class="flag4=='4' ? 'pc_box':''" @click="change('4')">慧眼-BI大数据分析</div>
              </router-link>
              <router-link to="/page/page5">
                <div :class="flag4=='5' ? 'pc_box':''" @click="change('5')"> 微信托管运营  </div>
              </router-link>
              <!-- <div :class="flag4=='2' ? 'pc_box':''" @click="change('2')">
               <router-link to="/page/page2">慧购-线上销售产品</router-link>
              </div>
              <div :class="flag4=='3' ? 'pc_box':''" @click="change('3')">
               <router-link to="/page/page3">慧投-媒介整合营销</router-link>
              </div>
              <div :class="flag4=='4' ? 'pc_box':''" @click="change('4')">
               <router-link to="/page/page4">慧眼-BI大数据分析</router-link>
              </div>
              <div :class="flag4=='5' ? 'pc_box':''" @click="change('5')">
               <router-link to="/page/page5">微信托管运营</router-link>
              </div> -->
            </div>
           <router-view></router-view>
      </div>
      <div class="p2">
            <img src="../assets/img/s-back.png" alt="">
      </div>
      <!-- 微信支付宝 -->
      <!-- <div class="payment">
        <div class="pay_wx" style="width: 100%;"><img style="width: 100%;" src="../assets/img/wx.png" alt=""></div>
        <div class="pay_zf" style="width: 100%;"><img  style="width: 100%;" src="../assets/img/sj.png" alt=""></div>
      </div> -->
      <!-- 经典案例 -->
      <div class="c_con c_case">
        <div style="text-align: center; width: 100%;">
          <div class="con_a lbox1" style="margin-left: 48%;">
          </div>
          <div class="con_b" style="font-size: 1.456rem;">
              <p >经典案例</p>
          </div>
        </div>
        <div class="al">
			<!-- 五环 -->
          <div class="ert" style="position: relative; " @mouseenter="str()" @mouseleave="str()">
            <div v-show="flag" class="er" >
            </div>
            <img  v-show="flag" src="../assets/img/er_wh.jpg" alt="">
            <img  class="pic" src="../assets/img/wh_case.jpg" style="width: 100%;height: 100%;" alt="">
          </div>
		  <!-- 梦想城 -->
          <div class="ert" style="position: relative; " @mouseenter="str1()" @mouseleave="str1()">
            <div v-show="flag1" class="er" >
            </div>
            <img  v-show="flag1" src="../assets/img/er_mx.jpg" alt="">
            <img src="../assets/img/drem_case.jpg" style="width: 100%;height: 100%;" alt="">
          </div>
          <!-- 长白 -->
          <div class="ert" style="position: relative; " @mouseenter="str2()" @mouseleave="str2()">
            <div v-show="flag2" class="er" >
            </div>
            <img  v-show="flag2" src="../assets/img/er_cb.jpg" alt="">
            <img  src="../assets/img/cb_case.jpg" style="width: 100%;height: 100%;" alt="">
          </div>
          <!-- 西市 -->
          <div class="ert" style="position: relative; " @mouseenter="str3()" @mouseleave="str3()">
            <div v-show="flag3" class="er" >
            </div>
            <img   v-show="flag3" src="../assets/img/er_xs.jpg" alt="">
            <img  src="../assets/img/xs_case.jpg" style="width: 100%;height: 100%;" alt="">
          </div>
        </div>
      </div>
      <div class="p3">
            <img src="../assets/img/s-back.png" alt="">
      </div>
      <!-- 合作商户 -->
      <div class="c_con c_cooperation" style="position: relative;">
        <div style="text-align: center; width: 100%;">
          <div class="con_a lbox1" style="margin-left: 48%;">
          </div>
          <div class="con_b" style="font-size: 1.456rem;">
              <p >合作商户</p>
          </div>
        </div>
        <div style="position: absolute;left: -3.328rem;width: 1.404rem;height: 3.796rem;top: 12.632rem;"><img src="../assets/img/arrow_l.png" alt=""></div>
        <div style="position: absolute;right: -3.328rem;width: 1.404rem;height: 3.796rem;top: 12.632rem;"><img src="../assets/img/arrow_r.png" alt=""></div>
        <div class="contr" style="overflow: hidden;margin-top: 2.132rem;">
          <div class="contrc" style="width: 155rem;">
            <div class="contrc1">
                <img src="../assets/img/1.png" alt="">
            </div>
            <div class="contrc1">
                <img src="../assets/img/2.png" alt="">
            </div>
            <div class="contrc1">
                <img src="../assets/img/3.png" alt="">
            </div>
            <div class="contrc1">
                <img src="../assets/img/4.png" alt="">
            </div>
            <div class="contrc1">
                <img src="../assets/img/5.png" alt="">
            </div>
            <div class="contrc1">
                <img src="../assets/img/6.png" alt="">
            </div>
            <div class="contrc1">
                <img src="../assets/img/7.png" alt="">
            </div>
            <div class="contrc1">
                <img src="../assets/img/8.png" alt="">
            </div>
            <div class="contrc1">
                <img src="../assets/img/9.png" alt="">
            </div>
            <div class="contrc1">
                <img src="../assets/img/10.png" alt="">
            </div>
            <div class="contrc1">
                <img src="../assets/img/11.png" alt="">
            </div>
            <div class="contrc1">
                <img src="../assets/img/1.png" alt="">
            </div>
            <div class="contrc1" style="margin-right: 0;">
                <img src="../assets/img/2.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="food">
      <div class="food_t" style="20px">
        <div class="food_l">
          <p>ADRESS：</p>
          <p>陕西省西安市雁塔区雁塔南路885号西安金辉环球广场</p>
        </div>
        <div class="food_r">
          <div>联系我们：</div>
          <div><img style="width: 100%;" src="../assets/img/erm.jpg" alt=""></div>
        </div>
      </div>
      <div class="food_b" style="16px">Copyright © 2018 企鹅互动网络版权所有[官方网站]   <a style="color:#FFF;" href="https://beian.miit.gov.cn/" target="_blank">陕ICP备16018502号-2</a></div>
    </div>

</div>
</template>
<script>
export default {
  name: "page",
  data () {
    return {
      list:[
          {
              url:"../../assets/img/1.png",
          },
          {
              url:"../../assets/img/2.png",
          },
          {
              url:"../../assets/img/3.png",
          },
          {
              url:"../../assets/img/4.png",
          },
          {
              url:"../../assets/img/5.png",
          },
          {
              url:"../../assets/img/6.png",
          },
          {
              url:"../../assets/img/7.png",
          },
          {
              url:"../../assets/img/8.png",
          },
          {
              url:"../../assets/img/9.png",
          },
          {
              url:"../../assets/img/10.png",
          },
          {
              url:"../../assets/img/11.png",
          }
      ],
       flag:false,
       flag1:false,
       flag2:false,
       flag3:false,
       flag4:'-1'
    };
  },
  methods:{
    str(){
      this.flag = !this.flag
    },
    str1(){
      this.flag1 = !this.flag1
    },
    str2(){
      this.flag2 = !this.flag2
    },
    str3(){
      this.flag3 = !this.flag3
    },
    change(n){
      this.flag4 = n
    }
  }
}
</script>
<style scoped>
  html{
    font-size:1vw;
  }
/* @keyframes move1{
            0%{
                transform: translateX(0);
            }
            7%{
                transform: translateX(0);
            }
            10%{
                transform: translateX(-10rem);
            }
            17%{
                transform: translateX(-10rem);

            }
            20%{
                transform: translateX(-20rem);

            }
            27%{
                transform: translateX(-20rem);

            }
            30%{
                transform: translateX(-30rem);

            }
            37%{
                transform: translateX(-30rem);

            }
            40%{
                transform: translateX(-40rem);

            }
            47%{
                transform: translateX(-40rem);

            }
            50%{
                transform: translateX(-51rem);
            }
            57%{
                transform: translateX(-51rem);
            }
            60%{
                transform: translateX(-61rem);
            }
            67%{
                transform: translateX(-61rem);
            }
            70%{
                transform: translateX(-71rem);
            }
            77%{
                transform: translateX(-71rem);
            }
            80%{
                transform: translateX(-81rem);
            }
            87%{
                transform: translateX(-81rem);
            }
            90%{
                transform: translateX(-92rem);
            }
            97%{
                transform: translateX(-92rem);
            }
            100%{
                transform: translateX(-101rem);
            }

        } */

@keyframes move2{
    0%{
       transform: translateX(0);
    }
    100%{
       transform: translateX(-72rem);
    }
}

  .page{
    width: 100%;
    position: relative;
  }
  /* 实体商业 */
.content{
  width: 100%;
  position: absolute;
}
.c_con{
  width: 58%;
  margin: 0 21%;
}
.con{
  position: absolute;
  top: -11.336rem;
  left: 0;
  right: 0;
}
.con_a{
  height: 0.104rem;
  background-color: #FFCE00;
}
.lbox1{
  width: 4%;
}
.lbox2{
   width: 17.5%;
}
.con_b{
  font-weight: bolder;
  white-space:nowrap;
  font-size: 1.46rem;
  line-height: 2.184rem;
  margin-top: 0.78rem;
}
.con_c{
  margin-top: 2.496rem;
  position: relative;
}
.con_c>div:nth-child(1){
  font-size: 0.936rem;
  margin-bottom: 0.936rem;
}
.con_c>div:nth-child(2){
  font-size: 0.832rem;
  line-height: 1.456rem;
}
/* 互动营销 */
.hd{
  background:linear-gradient(#E5E5E5,#F6F6F6);
  position: absolute;
  width: 100%;
  top: 9.56rem;
  padding: 3.12rem 0;
}
.hd_ct{
  width: 58%;
  margin: 0 21%;
  display: flex;
  justify-content: space-between;
  text-align: center;
}
.hd_ct>div{
  width: 11.5%;
}
.hd_ct>div img{
  width: 100%;
}
.text{
   font-size: 0.936rem;
   margin-top: 0.78rem;
}
/* 直击商业 */
.direct{
  position: relative;
  top: 26.832rem;
  text-align: center;
  height: 34.632rem;
}
.p1{
    width: 34%;
    height: 10.92rem;
    position: absolute;
    top: 32.396rem;
    left: 12.012rem;
}
.p1>img{
  width: 100%;
}
.p2{
    width: 34%;
    height: 17.16rem;
    position: absolute;
    top: 64.688rem;
    right: 0px;
    overflow: hidden;
}
.p2>img{
  width: 100%;
  position: absolute;
  right: -14.924rem;
}
.p3{
    width: 34%;
    height: 10.92rem;
    position: absolute;
    top: 104.728rem;
    left: -12.012rem;
}
.p3>img{
  width: 100%;
}
/* 微信支付宝 */
.payment{
  position: fixed;
  z-index: 88;
  top: 28%;
  right: 0;
  width: 6vw;
  height: 18vh;

}
.payment>div:nth-child(1){
 margin-bottom: 18%;
}
.separation{
  text-align: left;
  display: flex;
  justify-content: space-between;
  margin-top: 1.04rem;
}
.separation div{

  font-size: 0.936rem;
  padding: 1.3rem 1.04rem;
  text-align: center;
  border-radius: 10px;
  border: 1px solid #999999;
}
.separation .pc_box{
  background: #FFCE00;
  border: 1px solid #FFCE00;
}
/* 经典案例 */
.c_case{
  position: absolute;
 margin-top: 39rem;
}
.al{
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 5%;
  position: absolute;
}
.al>div{
   height: 25.636rem;
   width: 22.3%;
}
.al .pic{
   height: 100%;
   width: 100%;
}
.er{
  position: absolute;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: .7;
}
.ert img:nth-child(2){
  width: 90%;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  position: absolute;
  margin: auto
}
.ert{
  border: 4px solid #000000;
  border-radius: 10px;
  height: 493px;
}
/* 合作商户 */
.c_cooperation{
  position: absolute;
  margin-top: 74.048rem;
}
.c_cooperation>div{
  width: 100%;
}
.c_cooperation>div>img{
  width: 100%;
}
/* 底部 */
.food{
  width: 100%;
  height: 11.596rem;
  background: #333333;
  color: #FFFFFF;
  position: absolute;
  top: 133.15rem;

}
.food_t{
  width: 58%;
  margin: 0 21%;
  margin-top: 1.976rem;
}
.food_t>div{
  display: inline-block;
  vertical-align: middle;
}
.food_b{
  text-align: center;
}
.food_l{
      margin-top: 1.56rem;
      line-height: 1.56rem;
}
.food_r{
  float: right;
}
.food_r>div{
  display: inline-block;
  vertical-align: middle;
}
.food_r>div:nth-child(2){
  width: 5.72rem;
  height: 5.72rem;
  background: #FFFFFF;
  border-radius: 10px;
}
.food_b{
  margin-top: 1.56rem;
  font-size: 0.624rem;
}
.contrc1{
  display: inline-block;
  width: 10.4rem;
  margin-right: 1rem;
  animation: move2 50s linear infinite;
}
.contrc1 img{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/page.vue